import React from 'react';

const Resources: React.FC = () => {
  return (
    <div className="page">
      <div className="page-hero">
        <div className="container">
          <h1 className="page-title">Travel Resources</h1>
          <p className="page-subtitle">
            Everything you need to know for planning and enjoying your perfect trip
          </p>
        </div>
      </div>
      
      <section className="resources-section">
        <div className="container">
          <div className="resources-grid">
            <div className="resource-category">
              <h3>Travel Guides</h3>
              <div className="resource-items">
                <div className="resource-item">
                  <h4>First Time Traveler's Guide</h4>
                  <p>Essential tips and tricks for your first international adventure</p>
                </div>
                <div className="resource-item">
                  <h4>Budget Travel Mastery</h4>
                  <p>How to explore the world without breaking the bank</p>
                </div>
                <div className="resource-item">
                  <h4>Solo Travel Safety</h4>
                  <p>Stay safe and confident while traveling alone</p>
                </div>
                <div className="resource-item">
                  <h4>Family Travel Planning</h4>
                  <p>Making memories with kids and multiple generations</p>
                </div>
              </div>
            </div>
            
            <div className="resource-category">
              <h3>Practical Tips</h3>
              <div className="resource-items">
                <div className="resource-item">
                  <h4>Packing Essentials</h4>
                  <p>What to pack for different types of trips and climates</p>
                </div>
                <div className="resource-item">
                  <h4>Travel Documentation</h4>
                  <p>Passport, visa, and insurance requirements by country</p>
                </div>
                <div className="resource-item">
                  <h4>Health & Safety</h4>
                  <p>Vaccinations, medications, and health precautions</p>
                </div>
                <div className="resource-item">
                  <h4>Money & Banking</h4>
                  <p>Currency exchange, credit cards, and travel budgeting</p>
                </div>
              </div>
            </div>
            
            <div className="resource-category">
              <h3>Cultural Insights</h3>
              <div className="resource-items">
                <div className="resource-item">
                  <h4>Local Customs</h4>
                  <p>Understanding etiquette and traditions around the world</p>
                </div>
                <div className="resource-item">
                  <h4>Language Basics</h4>
                  <p>Essential phrases and communication tips</p>
                </div>
                <div className="resource-item">
                  <h4>Food & Dining</h4>
                  <p>Local cuisine guides and dining etiquette</p>
                </div>
                <div className="resource-item">
                  <h4>Cultural Experiences</h4>
                  <p>Festivals, traditions, and authentic local activities</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <section className="travel-tools">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">Travel Tools</h2>
            <p className="section-subtitle">
              Helpful tools and calculators to make your travel planning easier
            </p>
          </div>
          <div className="tools-grid">
            <div className="tool-card">
              <h3>Currency Converter</h3>
              <p>Real-time exchange rates for all major currencies</p>
            </div>
            <div className="tool-card">
              <h3>Weather Forecast</h3>
              <p>Global weather predictions to help you pack right</p>
            </div>
            <div className="tool-card">
              <h3>Time Zone Calculator</h3>
              <p>Never miss a flight or appointment with our time zone tool</p>
            </div>
            <div className="tool-card">
              <h3>Travel Checklist</h3>
              <p>Customizable checklists for different types of trips</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Resources; 